import { Component, OnDestroy, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../../services/user.service';
import { P } from '@angular/cdk/keycodes';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-super-admin-pro-import',
  templateUrl: './super-admin-pro-import.component.html',
  styleUrls: ['./super-admin-pro-import.component.scss']
})
export class SuperAdminProImportComponent implements OnInit, OnDestroy {

  importTypes = [];
  importYears = [];
  importQuarters = [];

  importType: string;
  importYear: number;
  importQuarter: string;

  importId: number;

  selectedFile: File = null;
  isUploading = false;

  importTypeSubscription;
  importYearSubscription;
  importQuarterSubscription;

  private _subscriptions = new Subscription();


  constructor(private importService: ImportService, private userService: UserService, private router: Router) { }
    

  ngOnInit() {

    console.log("ProSelectHeader init")
    this.importTypes = this.importService.importTypes;
    this.importYears = this.importService.importYears;
    this.importQuarters = this.importService.importQuarters;

    this.importTypeSubscription = this.importService.importType$.subscribe((x) => {
      this.importType = x;
    });

    this.importYearSubscription = this.importService.importYear$.subscribe((x) => {
      this.importYear = x;
    });

    this.importQuarterSubscription = this.importService.importQuarter$.subscribe((x) => {
      this.importQuarter = x;
    });

    this.importService.importId$.subscribe((xId) => {
      this.importId = xId;
    });

    this._subscriptions.add(this.importTypeSubscription)
    this._subscriptions.add(this.importYearSubscription)
    this._subscriptions.add(this.importQuarterSubscription)

  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  setImportType() {
    this.importService.setImportType(this.importType);
  }

  setImportYear() {
    this.importService.setImportYear(this.importYear);
  }

  setImportQuarter() {
    this.importService.setImportQuarter(this.importQuarter);
  }


  /**
   * Called when the user selects their import file
   * @param event 
   */
  onFileSelected(event) {
    this.selectedFile = event.target.files[0];
  }

  /**
   * This function makes an api request to upload a .csv or .xlsx file 
   * through the api.  The api returns the headesr from the excel file
   * which will then be used for mapping.
   */
  uploadPRO() {
    if (!this.selectedFile || this.isUploading == true) {

      // no file selected
      return;
    }
    else {
      this.isUploading = true;
      var headers = [];
      var filePath = '';

      this.importService.uploadPRO(this.selectedFile, this.importType, this.importYear, this.importQuarter, this.userService.currentUser.id)
        .subscribe(
          (response: any) => {
            // Handle successful response
            headers = response.headers;            

            // console.log(headers);

            //store headers for use on mapping view
            this.importService.setImportedHeaders(headers);

            this.importService.setImportId(response.storedFileDetails.id)

            filePath = response.storedFileDetails.file_path;

            //store the file path
            this.importService.setImportedFilePath(filePath)

            //navigate to mapping step
            this.importService.setShowHeaderMapper(true);

            this.router.navigate(['data/pro/label-mapper'], {
              queryParams: { importId: response.storedFileDetails.id }
            });

            this.isUploading = false;

          },
          (error: HttpErrorResponse) => {
            // Handle HTTP error
            if (error.error instanceof ErrorEvent) {
              // Client-side errors (e.g., network issues)
              console.error('An error occurred:', error.error.message);
            } else {
              // Backend returned unsuccessful response code
              console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`
              );
            }
            this.isUploading = false;
          }
        );
    }
  }

}
